import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const faqs = [
  { qKey: "faqQ1", aKey: "faqA1" },
  { qKey: "faqQ2", aKey: "faqA2" },
  { qKey: "faqQ3", aKey: "faqA3" },
  { qKey: "faqQ4", aKey: "faqA4" },
  { qKey: "faqQ5", aKey: "faqA5" },
];

const articles = [
  {
    path: "/artigo-cssbuy-spreadsheet",
    icon: "ri-file-text-line",
    iconBg: "bg-primary-100",
    iconColor: "text-primary-600",
    hoverColor: "group-hover:text-primary-600",
    accentColor: "text-primary-600",
    title: "CSSBuy Spreadsheet: Guia Definitivo",
    desc: "Aprenda tudo sobre como usar o CSSBuy Spreadsheet para encontrar os melhores produtos da China. Guia passo a passo com dicas de especialistas.",
    imageUrl: "https://readdy.ai/api/search-image?query=Overhead%20photography%20of%20laptop%20displaying%20spreadsheet%20next%20to%20coffee%20cup%20on%20minimalist%20wooden%20desk%2C%20warm%20morning%20light%2C%20clean%20workspace%2C%20productivity%20lifestyle%2C%20soft%20shadows%2C%20cozy%20modern%20home%20office&width=600&height=340&seq=art-card-01-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-sneakers",
    icon: "ri-footprint-line",
    iconBg: "bg-accent-100",
    iconColor: "text-accent-600",
    hoverColor: "group-hover:text-accent-600",
    accentColor: "text-accent-600",
    title: "Melhores Tênis da China 2026",
    desc: "Descubra os tênis mais procurados nas planilhas CSSBuy. Comparação de preços, qualidade e lojas recomendadas.",
    imageUrl: "https://readdy.ai/api/search-image?query=Creative%20flat%20lay%20of%20colorful%20sneakers%20arranged%20in%20circle%20on%20light%20grey%20backdrop%2C%20top%20down%20view%2C%20bright%20studio%20lighting%2C%20sneakerhead%20collection%20display%2C%20vibrant%20colors%2C%20modern%20streetwear%20photography&width=600&height=340&seq=art-card-02-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-roupas",
    icon: "ri-t-shirt-line",
    iconBg: "bg-secondary-100",
    iconColor: "text-secondary-600",
    hoverColor: "group-hover:text-secondary-600",
    accentColor: "text-secondary-600",
    title: "Guia de Roupas por Atacado",
    desc: "Como comprar roupas de qualidade da China usando planilhas CSSBuy. Dicas de tamanhos, tecidos e fornecedores confiáveis.",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20clothing%20rack%20with%20organized%20colorful%20garments%20in%20bright%20boutique%20store%2C%20soft%20natural%20light%2C%20retail%20display%20aesthetic%2C%20textile%20textures%2C%20modern%20fashion%20retail%20photography%2C%20clean%20organized%20composition&width=600&height=340&seq=art-card-03-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-bolsas",
    icon: "ri-handbag-line",
    iconBg: "bg-primary-100",
    iconColor: "text-primary-600",
    hoverColor: "group-hover:text-primary-600",
    accentColor: "text-primary-600",
    title: "Bolsas de Luxo: Guia Completo",
    desc: "Encontre bolsas de grife e alta qualidade nas planilhas CSSBuy. Compare materiais, preços e fornecedores verificados.",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20display%20of%20designer%20handbags%20on%20white%20marble%20shelves%20in%20luxury%20boutique%2C%20soft%20golden%20lighting%2C%20premium%20retail%20interior%2C%20leather%20textures%2C%20sophisticated%20fashion%20photography%2C%20high%20end%20shopping%20atmosphere&width=600&height=340&seq=art-card-04-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-eletronicos",
    icon: "ri-smartphone-line",
    iconBg: "bg-accent-100",
    iconColor: "text-accent-600",
    hoverColor: "group-hover:text-accent-600",
    accentColor: "text-accent-600",
    title: "Eletrônicos da China: Guia 2026",
    desc: "Smartphones, fones, gadgets. Como verificar compatibilidade e garantias antes de comprar da China.",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20tech%20gadgets%20arranged%20on%20minimalist%20white%20desk%2C%20smartphone%20earbuds%20smartwatch%2C%20clean%20product%20photography%2C%20soft%20natural%20light%2C%20contemporary%20tech%20lifestyle%2C%20organized%20composition&width=600&height=340&seq=art-card-05-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-perfumes",
    icon: "ri-contrast-drop-line",
    iconBg: "bg-secondary-100",
    iconColor: "text-secondary-600",
    hoverColor: "group-hover:text-secondary-600",
    accentColor: "text-secondary-600",
    title: "Perfumes Importados: Guia CSSBuy",
    desc: "Encontre perfumes originais e contratipos de qualidade. Dicas para identificar fragrâncias autênticas.",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottles%20displayed%20on%20glass%20shelf%20with%20warm%20ambient%20backlighting%2C%20elegant%20fragrance%20boutique%2C%20golden%20and%20amber%20tones%2C%20sophisticated%20beauty%20photography%2C%20refined%20luxury%20atmosphere%2C%20soft%20bokeh%20background&width=600&height=340&seq=art-card-06-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-acessorios",
    icon: "ri-glasses-line",
    iconBg: "bg-primary-100",
    iconColor: "text-primary-600",
    hoverColor: "group-hover:text-primary-600",
    accentColor: "text-primary-600",
    title: "Acessórios de Moda: Top Lojas",
    desc: "Relógios, óculos e joias dos melhores fornecedores chineses. Dicas para garantir qualidade nas compras.",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20sunglasses%20watches%20and%20jewelry%20artfully%20arranged%20on%20velvet%20surface%2C%20soft%20directional%20lighting%2C%20luxury%20accessories%20flat%20lay%2C%20metallic%20reflections%2C%20editorial%20fashion%20photography%2C%20elegant%20composition&width=600&height=340&seq=art-card-07-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-tamanhos",
    icon: "ri-ruler-line",
    iconBg: "bg-accent-100",
    iconColor: "text-accent-600",
    hoverColor: "group-hover:text-accent-600",
    accentColor: "text-accent-600",
    title: "Guia de Tamanhos: Roupas Chinesas",
    desc: "Tabela completa de conversão China x Brasil x Portugal. Nunca mais erre no tamanho das suas compras.",
    imageUrl: "https://readdy.ai/api/search-image?query=Measuring%20tape%20and%20size%20chart%20on%20light%20wooden%20table%20next%20to%20folded%20clothing%2C%20top%20down%20flat%20lay%2C%20bright%20natural%20light%2C%20fashion%20design%20workspace%2C%20organized%20minimalist%20composition%2C%20clean%20professional%20look&width=600&height=340&seq=art-card-08-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-comparacao",
    icon: "ri-scales-line",
    iconBg: "bg-secondary-100",
    iconColor: "text-secondary-600",
    hoverColor: "group-hover:text-secondary-600",
    accentColor: "text-secondary-600",
    title: "CSSBuy vs Outros Agentes",
    desc: "Comparação detalhada entre CSSBuy, Wegobuy, Pandabuy. Preços, taxas e velocidade de envio comparados.",
    imageUrl: "https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20concept%20with%20two%20laptops%20displaying%20charts%20on%20clean%20desk%2C%20business%20analytics%20theme%2C%20soft%20office%20lighting%2C%20professional%20workspace%2C%20modern%20minimalist%2C%20data%20comparison%20visual&width=600&height=340&seq=art-card-09-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-taxas",
    icon: "ri-file-list-3-line",
    iconBg: "bg-primary-100",
    iconColor: "text-primary-600",
    hoverColor: "group-hover:text-primary-600",
    accentColor: "text-primary-600",
    title: "Como Evitar Taxas de Importação",
    desc: "Estratégias para minimizar taxas alfandegárias. Dicas de declaração e métodos de envio econômicos.",
    imageUrl: "https://readdy.ai/api/search-image?query=Shipping%20boxes%20and%20customs%20documents%20on%20office%20desk%2C%20international%20logistics%20concept%2C%20bright%20natural%20light%2C%20professional%20ecommerce%20photography%2C%20organized%20workspace%2C%20global%20trade%20theme&width=600&height=340&seq=art-card-10-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-weidian",
    icon: "ri-store-2-line",
    iconBg: "bg-accent-100",
    iconColor: "text-accent-600",
    hoverColor: "group-hover:text-accent-600",
    accentColor: "text-accent-600",
    title: "Melhores Lojas Weidian 2026",
    desc: "Lista das lojas Weidian mais confiáveis para tênis, roupas e acessórios. Avaliações reais dos compradores.",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20online%20shopping%20interface%20displayed%20on%20tablet%20surrounded%20by%20shopping%20bags%2C%20modern%20ecommerce%20lifestyle%2C%20warm%20indoor%20lighting%2C%20contemporary%20digital%20shopping%20photography%2C%20clean%20composition&width=600&height=340&seq=art-card-11-v2&orientation=landscape",
  },
  {
    path: "/artigo-cssbuy-envio",
    icon: "ri-ship-line",
    iconBg: "bg-secondary-100",
    iconColor: "text-secondary-600",
    hoverColor: "group-hover:text-secondary-600",
    accentColor: "text-secondary-600",
    title: "Envio Internacional: Dicas CSSBuy",
    desc: "Compare métodos de envio China → Portugal. Prazos, custos e rastreamento para cada tipo de produto.",
    imageUrl: "https://readdy.ai/api/search-image?query=Cargo%20shipping%20containers%20and%20logistics%20warehouse%20with%20packages%2C%20global%20delivery%20concept%2C%20bright%20industrial%20lighting%2C%20international%20trade%20photography%2C%20organized%20parcels%2C%20modern%20supply%20chain%20visual&width=600&height=340&seq=art-card-12-v2&orientation=landscape",
  },
];

export default function FAQArticleSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section id="faq" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-12">
          <div className="lg:col-span-2">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium uppercase tracking-wider mb-4">
              FAQ
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              {t("sectionFAQ")}
            </h2>
            <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
              Respostas para as dúvidas mais comuns sobre como usar o CSSBuy Spreadsheet para comprar produtos da China com segurança e economia.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-question-answer-line"></i> Mais Perguntas
            </a>
          </div>

          <div className="lg:col-span-3 space-y-3">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-900 list-none">
                  <span>{t(faq.qKey)}</span>
                  <span className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0 ml-3 group-open:rotate-45 transition-transform">
                    <i className="ri-add-line text-foreground-600 text-sm"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {t(faq.aKey)}
                </div>
              </details>
            ))}
          </div>
        </div>

        <div id="articles" className="mt-14 pt-10 border-t border-background-200">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium uppercase tracking-wider mb-4">
              Guias e Artigos
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {t("sectionArticles")}
            </h2>
            <p className="text-sm text-foreground-600 max-w-lg mx-auto">
              {t("sectionArticlesDesc")}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {articles.map((article, idx) => (
              <button
                key={idx}
                onClick={() => { navigate(article.path); window.scrollTo(0, 0); }}
                className="group bg-background-100 rounded-2xl overflow-hidden text-left hover:bg-background-200/70 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <div className={`w-9 h-9 rounded-full ${article.iconBg} flex items-center justify-center mb-3`}>
                    <i className={`${article.icon} ${article.iconColor} text-sm`}></i>
                  </div>
                  <h3 className={`text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 leading-snug ${article.hoverColor} transition-colors`}>
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed flex-1">
                    {article.desc}
                  </p>
                  <span className={`text-xs font-medium mt-3 whitespace-nowrap ${article.accentColor}`}>
                    {t("btnReadArticle")} <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </div>
              </button>
            ))}
          </div>

          <div className="text-center mt-10">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t("btnStartBuying")} <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}